import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SUPPLIER_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import SupplierForm from './SupplierForm';
import { postSupplier } from '../../../../actions/food/Supplier';

const NewSupplier = ({ breadcrumbs, dispatchPostSupplier }) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      businessId: formValues.businessId.value,
      billingType: formValues.billingType.value,
      type: formValues.type.value,
      creditTime: formValues.creditTime.value,
      locationId: formValues.locationId.value,
      userId: formValues.userId.value,
      active: true,
      supplierFoodTypeList: formValues.supplierFoodTypeList
        ? formValues.supplierFoodTypeList.map((item) => ({
            foodId: item.food.value,
            cost: item.cost,
            publicType: item.publicType.value,
          }))
        : [],
    };

    dispatchPostSupplier(newFormValues);
  };

  const content = <SupplierForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Proveedor"
      subtitle="Crear proveedor"
      content={content}
    />
  );
};

NewSupplier.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostSupplier: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostSupplier: postSupplier,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Proveedores',
      href: SUPPLIER_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewSupplier);
